import "./audio_zone.component.style.scss";
import { createRef, FC, useContext, useState } from "react";
import AudioZoneComponentProps from "./audio_zone.component.props";
import ButtonComponent from "../../../../../components/button/button.component";
import di from "../../../../../../dependency_injection";
import CheckAudioWithQuestionsUseCase, { CheckAudioWithQuestionsUseCaseName } from "../../../../../../domain/use_cases/qa_resume/check_audio_with_questions.use_case";
import { isLeft } from "fp-ts/lib/Either";
import ModalsContextType from "../../../../../../domain/providers/modal/ModalsContextType";
import ModalsContext from "../../../../../providers/modal/ModalsContext";
import KeyWordLocalization from "../../../../../utils/KeyWordLocalization";
import ResultIAAudioComponent from "../result_question/result_ia_audio.component";
import LocalizationContextType from "../../../../../../domain/providers/localization/LocalizationContextType";
import LocalizationContext from "../../../../../providers/localization/LocalizationContext";
import QAResultEntity from "../../../../../../domain/entities/qa_result.entity";
import { CircularProgressbar } from 'react-circular-progressbar';
import HumanAgentEntity from "../../../../../../domain/entities/human_agent.entity";
import { useForm } from "react-hook-form";
import AutoCompleteWithCheckComponent from "../../../../../components/autocompleteWithCheck/AutoCompleteWithCheckComponent";
import { AutoCompleteItem } from "../../../../../components/autocompleteWithCheck/AutoCompleteWithCheckProps";
import SearchHumanAgentsUseCase, { SearchHumanAgentsUseCaseName } from "../../../../../../domain/use_cases/human_agent/search_human_agents.use_case";
import QAResponseQuestionEntity from "../../../../../../domain/entities/qa_response_question.entity";


const AudioZoneComponent: FC<AudioZoneComponentProps> = ({ qaAgent }) => {
    const { addToast, openModalCustom } = useContext(ModalsContext) as ModalsContextType;
    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;
    const [audioProcesing, setAudioProcessing] = useState<{ audioName: string, randomId: string, message: string, progress: number, error?: boolean, result?: QAResultEntity }[]>([]);
    const formInfo = useForm();
    const { formState: { errors }, register, watch, setValue, getValues } = formInfo;
    const [dragging, setDragging] = useState(false);
    const inputRef = createRef<HTMLInputElement>();
    const audioCall: { audioName: string, randomId: string, message: string, progress: number, error?: boolean, result?: QAResultEntity }[] = [];

    const _handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        // event.preventDefault();
        setDragging(false);
    }

    const _handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        setDragging(true);
        event.preventDefault();
        event.stopPropagation();
    }

    const _handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
    };

    const _updateAudioProcessing = (nameFile: string, randomId: string, progress: number, message: string, error?: boolean, result?: QAResultEntity | undefined) => {
        const copyAudios = [...audioCall];
        const edited = copyAudios.find((audio) => audio.randomId == randomId);
        if (edited == undefined) {
            copyAudios.push({ audioName: nameFile, randomId, message, progress, error, result });
            audioCall.push({ audioName: nameFile, randomId, message, progress, error, result });
            setAudioProcessing(copyAudios);
        } else {
            edited.message = message;
            edited.progress = progress;
            edited.error = error;
            edited.result = result;
            setAudioProcessing(copyAudios);
        }
    }


    const _handleSelectFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files == null || event.target.files.length == 0) return;
    
        const selectedHuman = getValues()[KeyWordLocalization.AudioZoneComponentSelectHuman]?.at(0);
        if (selectedHuman == undefined) {
            event.target.value = "";
            return addToast(i18n(KeyWordLocalization.AudioZoneComponentSelectHumanError), "error", undefined);
        }
    
        const allowedMimeTypes = [
            'audio/mpeg',
            'audio/wav',
            'audio/x-wav',
            'audio/flac',
            'audio/x-flac',
            'audio/aac',
            'audio/ogg',
            'audio/webm',
            'audio/mp4',
            'audio/x-m4a'
        ];
    
        const files = Array.from(event.target.files);
    
        // Convertir a promesas paralelas
        const uploadPromises = files.map(async (file) => {
            const audioName = file.name ?? "";
            const randomId = Math.random().toString(36).substring(7);
    
            if (!allowedMimeTypes.includes(file.type)) {
                _updateAudioProcessing(audioName, randomId, 0, `${file.name}: ${i18n(KeyWordLocalization.UnknownError)}`, true, undefined);
                addToast(`${file.name}: ${i18n(KeyWordLocalization.UnknownError)}`, "error", undefined);
                return;
            }
    
            // Inicializar el estado
            _updateAudioProcessing(audioName, randomId, 0, i18n(KeyWordLocalization.CheckAudioWithQuestionsUseCaseProcessingPetiton), false, undefined);
    
            try {
                const response = await di.get<CheckAudioWithQuestionsUseCase>(CheckAudioWithQuestionsUseCaseName).call({
                    humanAgent: selectedHuman,
                    audio: file,
                    aiAgent: qaAgent,
                    onCallBack: (progress, text) => _updateAudioProcessing(audioName, randomId, progress, text),
                });
    
                if (isLeft(response)) {
                    _updateAudioProcessing(audioName, randomId, 0, i18n(response.left.code ?? KeyWordLocalization.CheckAudioWithQuestionsUseCaseProcessingPetiton), true, undefined);
                    addToast(i18n(response.left.code ?? KeyWordLocalization.UnknownError), "error", undefined);
                    return;
                }
    
                addToast(i18n(KeyWordLocalization.AudioZoneComponentAudioUploaded), "success", undefined);
                _updateAudioProcessing(audioName, randomId, 100, i18n(KeyWordLocalization.CheckAudioWithQuestionsUseCaseDone), false, response.right);
            } catch (err) {
                console.error(err);
                _updateAudioProcessing(audioName, randomId, 0, i18n(KeyWordLocalization.UnknownError), true, undefined);
                addToast(`${file.name}: ${i18n(KeyWordLocalization.UnknownError)}`, "error", undefined);
            }
        });
    
        // Esperar todas las subidas en paralelo
        await Promise.allSettled(uploadPromises);
    
        event.target.value = "";
    };
    
    

    const _reloadResult = async (respone: QAResponseQuestionEntity, result: QAResultEntity) => {
        //update audio result wiht id with new data
        const copyAudios = [...audioCall];
        //find result in result->categories->questions->response
        for (const category of result.categories) {
            for (const question of category.questions) {
                if (question.response?.id == respone.id) {
                    question.response = respone;
                    break;
                }
            }
        }
        copyAudios.forEach((audio) => {
            if (audio.result?.id == result.id) {
                audio.result = result;
                return; // Exit the forEach loop
            }
        });
        setAudioProcessing(copyAudios);
    }
    const _handleOpenResults = async (result?: QAResultEntity) => {
        if (result == undefined) return;
        openModalCustom("lg", i18n(KeyWordLocalization.AudioZoneComponentResultTitle), <ResultIAAudioComponent result={result} reload={(response) => _reloadResult(response, result)} />);
    }

    const _onSearchHuman = async (word: string): Promise<AutoCompleteItem<HumanAgentEntity>[]> => {
        const response = await di.get<SearchHumanAgentsUseCase>(SearchHumanAgentsUseCaseName).call({
            itemsPerPage: 20,
            page: 1,
            query: word,
        });
        if (isLeft(response)) return [];
        const parsed = response.right.data.map((item) => {
            return {
                label: item.name,
                id: item.id,
                aditionalValue: item,
            }
        });
        return parsed;
    }

    return <div className="audio_zone_component" onDragOver={_handleDragOver} onDrop={_handleDrop} onDragLeave={_handleDragLeave} >
        <h3 style={{ fontSize: '1.5em' }}>{i18n(KeyWordLocalization.AudioZoneComponentTitle)}</h3>
        <AutoCompleteWithCheckComponent multiple={false} keyName={KeyWordLocalization.AudioZoneComponentSelectHuman} label={i18n(KeyWordLocalization.AudioZoneComponentSelectHuman)} formInfo={formInfo} onSearch={_onSearchHuman} />
        <div className="drop_zone my-3">
            <input type="file" multiple accept="audio/*" onChange={_handleSelectFile} ref={inputRef} />
            {dragging && <div className="dragging">
                <div className="pulse">
                    <span className="material-symbols-outlined">cloud_upload</span>
                    {i18n(KeyWordLocalization.AudioZoneComponentDropHere)}
                </div>
            </div>}
            <div className="description">
                <div className="mb-2">
                    {i18n(KeyWordLocalization.AudioZoneComponentJustDrop)}
                </div><ButtonComponent text="Select a file" />
            </div>
        </div>
        {audioProcesing.map((audio, index) => <div key={index} className="item_loading my-3 hover" onClick={() => _handleOpenResults(audio.result)}>
            <div className="d-flex align-items-center">
                <div className="d-flex flex-grow-1 flex-column overflow-hidden">
                    <div className="text_ellipsis">
                        <strong>{audio.audioName}</strong>
                    </div>
                    <div className="w-100 d-flex justify-content-start text_ellipsis">
                        {audio.error == true && <div className="text-danger" role="alert">{i18n(audio.message)}</div>}
                        {audio.result && <div className="text-success" role="alert">{i18n(audio.message)}</div>}
                        {!audio.error && !audio.result && <span>{i18n(audio.message)}</span>}
                    </div>
                </div>
                <div className="ms-2">
                    {audio.error && <span className="material-symbols-outlined text-danger">error</span>}
                    {audio.result && <span className="material-symbols-outlined text-success">check</span>}
                    {!audio.error && !audio.result && <div style={{ width: '1.5em' }}>
                        <CircularProgressbar value={audio.progress} />
                    </div>
                    }
                </div>
            </div>
        </div>)}

    </div>
}

export default AudioZoneComponent;